
App.controller('termsAndConditions',[ '$scope','$location','$http','$window',function( $scope,$location,$http,$window){
    $scope.scrollTo=function () {
        $('html, body').animate({
            scrollTop: $(".downloadBackground").offset().top - 100
        }, 1000);
    }
    $window.scrollTo(0, 0);
}])